module.exports = __webpack_public_path__ + "img/MULLIGANS..61604b90.jpg";